<template>
    <div>
        <h2 class="page-header">Google Calendar の設定</h2>
        <p class="sentence">
            チームの予定を管理する Google Calendar に接続するための設定をします。
        </p>
        <h4 class="info-message">
            <span class="failer" v-if="this.calendarErrorType == this.$root.$options.Const.CALENDER_ERROR_INVALID_PARAMS">カレンダーID または APIキーが間違っています。</span>
            <span class="failer" v-if="this.calendarErrorType == this.$root.$options.Const.CALENDAR_ERROR_UNKNOWN">指定したカレンダーID は存在しません。</span>&nbsp;
        </h4>
        <div class="form-group">
            <label class="control-label" for="calendar-id">カレンダーID</label>
            <input type="text" class="form-control" id="calendar-id" size="25" maxlength="60" v-model="newCalendarId"/>
            <a class="btn btn-dark" target="_blank" href="https://www.bitscheduler.com/guide.html#get-calendar-id">
                カレンダーIDの取得方法はこちら&nbsp;<i class="material-icons md-icon dp16">open_in_new</i>
            </a>
        </div>
        <div class="form-group">
            <label class="control-label" for="api-key">APIキー</label>
            <input type="text" class="form-control" id="api-key" size="25" maxlength="60" v-model="newApiKey"/>
            <a class="btn btn-dark" target="_blank" href="https://www.bitscheduler.com/guide.html#get-apikey">
                APIキーの取得方法はこちら&nbsp;<i class="material-icons md-icon dp16">open_in_new</i>
            </a>
        </div>
        <div class="button-panel">
            <button id="back" class="btn btn-raised btn-dark" v-if="backEnable" @click="back()">back</button>
            <button id="confirmation" class="btn btn-raised btn-primary commit" v-bind:disabled="! this.newCalendarId || ! this.newApiKey" @click="confirmCalendar()">確認</button>
        </div>
        <calendar-list-modal v-if="this.showConfirmModal" v-bind:calendars="this.calendars" @close-modal="closeModal" @save-calendar-data="saveCalendarData" />
    </div>
</template>

<script>
    import Vue from 'vue'
    import Team from '../models/Team.js'
    import GoogleCalendar from '../services/GoogleCalendar.js'
    import CalendarListModal from '../components/CalendarListModal.vue'

    export default {
        components: {
            CalendarListModal,
        },
        data: function() {
            return {
                newCalendarId: null,
                newApiKey: null,
                showConfirmModal: false,
                calendarErrorType: 0,
            }
        },
        props: {
            backEnable: Boolean,
        },
        methods: {
            back: /* async */ function() {
                // let team = await Team.findByOwnerId(Vue.prototype.$ownerId)
                // team.remove()
                this.$router.back()
            },
            closeModal: function() {
                console.info('call closeModal()')
                this.showConfirmModal = false
            },
            confirmCalendar: function() {
                let that = this
                console.info(`calendarId : ${that.newCalendarId}, apiKey : ${that.newApiKey}`)

                GoogleCalendar.request(that.newCalendarId, that.newApiKey).then(async function(data) {
                    that.calendars = await GoogleCalendar.convertCalendarList(data);
                    that.showConfirmModal = true
                    that.calendarErrorType = 0
                })
                .catch(function(status) {
                    if (status == 400) {
                        that.calendarErrorType = that.$root.$options.Const.CALENDER_ERROR_INVALID_PARAMS
                    }
                    else {
                        that.calendarErrorType = that.$root.$options.Const.CALENDAR_ERROR_UNKNOWN
                    }
                })
            },
            saveCalendarData: function() {
                let that = this
                that.$emit('save-calendar-data', that.newCalendarId, that.newApiKey)
                that.showConfirmModal = false
            },
            setDefaultData: function(calendarId, apiKey) {
                this.newCalendarId = calendarId,
                this.newApiKey = apiKey
            },
        },
    }
</script>
